// eslint-disable-next-line import/prefer-default-export
export const VISIBILITY_STATE = {
  VISIBLE: 'visible',
  HIDDEN: 'hidden',
};
